var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('save-button', {
    staticClass: "right-15 top-15",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": _vm.saveReferent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', [_vm._v("\n      Modifier le compte référent de "), _c('br'), _vm._v("\n      " + _vm._s(_vm.referentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referentToEdit.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center my-10"
  }, [_c('ProfilePicture', {
    attrs: {
      "show-edit-link": true,
      "other-object": _vm.referentToEdit,
      "size": "max-w-36 w-36 h-36"
    },
    on: {
      "changeProfileImageToAnotherUser": function (urlPicture) {
        _vm.changeProfileImageToAnotherUser(urlPicture);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-300 border-2 rounded-lg"
  }, [_c('div', {
    staticClass: "my-4 mx-8"
  }, [_c('p', {
    staticClass: "text-sm italic font-medium text-gray-600"
  }, [_vm._v("\n            Nom d'utilisateur\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            " + _vm._s(_vm.referentToEdit.username) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "my-10 w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/10"
  }, [_c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "firstname",
      "libelle": "Prénom",
      "value": _vm.referentToEdit.firstname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.firstname'] || [])[0],
      "disabled": _vm.isAdminPayer
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "lastname",
      "libelle": "Nom",
      "value": _vm.referentToEdit.lastname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.lastname'] || [])[0],
      "disabled": _vm.isAdminPayer
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "company",
      "libelle": "Entreprise",
      "value": ((_vm.referentToEdit.companies || [])[0] || {}).name,
      "disabled": true
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "fonction",
      "libelle": "Fonction",
      "value": (((_vm.referentToEdit.companies || [])[0] || {}).pivot || {}).function,
      "disabled": _vm.isAdminPayer
    },
    on: {
      "input": function (newValue) {
        (((_vm.referentToEdit.companies || [])[0] || {}).pivot || {}).function = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "email",
      "type": "email",
      "libelle": "Email",
      "value": _vm.referentToEdit.email,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.email'] || [])[0],
      "disabled": _vm.isAdminPayer || _vm.isAdminEntreprise
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.email = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "phone_number",
      "libelle": "Téléphone",
      "value": _vm.referentToEdit.telephone,
      "disabled": _vm.isAdminPayer,
      "error": true,
      "type": "tel"
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.telephone = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full lg:col-span-6"
  }, [_c('input-select', {
    attrs: {
      "name": "role",
      "libelle": "Rôle par défaut",
      "value": _vm.role,
      "datas": _vm.list_roles,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.role'] || [])[0],
      "disabled": _vm.isAdminPayer
    },
    on: {
      "input": function (newValue) {
        _vm.changeRole(newValue);
      }
    }
  }), _vm._v(" "), _vm.isDisplayConfirmChangeRole ? _c('div', {
    staticClass: "text-sm text-red-500"
  }, [_c('p', [_vm._v("\n              Attention, sans modifications de votre part, les rôles liés aux\n              bénéficiaires rattachés à\n              " + _vm._s(_vm.referentToEdit.firstname + ' ' + _vm.referentToEdit.lastname) + "\n              resteront inchangés.\n            ")])]) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-full",
    attrs: {
      "name": "address",
      "libelle": "Adresse postale",
      "value": _vm.referentToEdit.address,
      "disabled": _vm.isAdminPayer
    },
    on: {
      "input": function (newValue) {
        _vm.referentToEdit.address = newValue;
      }
    }
  })], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }